
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/my-account/profile/privacy",
      function () {
        return require("private-next-pages/my-account/profile/privacy.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/my-account/profile/privacy"])
      });
    }
  